import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("lab_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("lab_token");
    if (token && !user) {
      api
        .get("/auth/me")
        .then((r) => {
          setUser(r.data);
          localStorage.setItem("lab_user", JSON.stringify(r.data));
        })
        .catch(() => {});
    }
  }, [user]);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("lab_token", data.token);
      localStorage.setItem("lab_user", JSON.stringify(data.user));
      // Pré-selecionar filial conforme login (geo ou cadastro)
      if (data.filial_ativa) {
        localStorage.setItem("filial_selecionada", data.filial_ativa);
      }
      setUser(data.user);
      return data;
    } finally {
      setLoading(false);
    }
  };

  const loginWithGoogleSession = async (sessionId) => {
    setLoading(true);
    try {
      const { data } = await api.post("/portal/auth/google-session", { session_id: sessionId });
      localStorage.setItem("lab_token", data.token);
      localStorage.setItem("lab_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("lab_token");
    localStorage.removeItem("lab_user");
    localStorage.removeItem("filial_selecionada");
    setUser(null);
  };

  const updateUser = (newUser) => {
    setUser(newUser);
    if (newUser) {
      localStorage.setItem("lab_user", JSON.stringify(newUser));
    }
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, loginWithGoogleSession, logout, setUser: updateUser }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
